import { asyncFn } from './asyncFn';
import { baseUrl, secrets } from '../../../globalVars/data';
import { argSel, getCtData, goTo, setData } from '../../project';
import { getOrderData } from './helpers/getOrderData';

import {
  runTransaction,
  doc,
  updateDoc,
  DocumentReference,
} from 'firebase/firestore';
import { firestoreOutFlax } from '../../functions/firebase/firebase';
import { updateDocTool } from '../../functions/firebase/updateDoc';
import { setDocTool } from '../../functions/firebase/setDoc';
import { TMergedLocalBikes } from '../mergeLocationBikes';
import { setCtDataError, setErrorTrue } from './helpers/setCtDataError';
import { createCustomer } from './createCustomer';
import { checkoutPath } from './helpers/paths';
import { getCardHash } from './getCardHash';
import { errFnc } from '.';
import { unlockBike } from './helpers/unlockBike';

type Tprops = {
  args: any;
  pass: {
    ipt1: any[];
    ipt2: string;
    ipt3: any[];
  };
};

// --- Errors path
// all.apis.msgs.condShow
// all.apis.msgs.error
export const payAndSetFireBase = async (props?: Tprops) => {
  const customerId = getCtData('all.userData.customerId');
  console.log('pagarme', 'Gerando Pag. C.Crédito...', { customerId });
  setData({ path: 'all.toggles.loaderPurchase', value: 'show' });

  // -----------------------------------------------------
  // 1 ||||| --------- Check IF is A New Pagar.Me Customer
  // -----------------------------------------------------
  if (!customerId) {
    console.log('pagarme', 'New Customer');
    // const resCustomer = await createCustomer().catch(errFnc);
    const resCus = await createCustomer().catch(errFnc);
    console.log({ resCus });
    if (resCus !== 'follow') return;
  }

  // ------------------------------------------------------------------
  // 2 ||||| --------- Check IF is FIRST PURCHASE - Create Credit Card
  // ------------------------------------------------------------------
  const cardId = getCtData('all.userData.paymentData.id');
  const firstPurchase = !cardId;

  if (firstPurchase) {
    console.log('pagarme', 'First Purchase (Create Token)');
    const resCrdHash = await getCardHash();
    if (resCrdHash !== 'follow') return;

    setData({ path: 'all.userData.paymentData', value: resCrdHash });
  }

  // -------------------------------------------------------------------
  // 3 ||||| --------- Check IF MethodPay & Customer OK, Then Send Order
  // -------------------------------------------------------------------
  // ---------- Get CtData
  const processedData = getOrderData('ccard');

  // ---------- EndPoint
  const url = baseUrl + '/orders';

  // ---------- Headers
  const myHeaders = new Headers();
  myHeaders.append('accept', 'application/json');
  myHeaders.append('Content-Type', 'application/json');
  myHeaders.append('Authorization', `Basic ${secrets.sk}`);

  console.log('Create Order >>>>>>>>>>>>>>>>>>', { processedData });

  // ---------- Body
  const raw = JSON.stringify(processedData);

  // ---------- Request Config
  const reqConfig = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  // ---------------------------
  // ----------- SET CALL API --
  // ---------------------------
  const callRequest = await asyncFn(url, reqConfig).catch(errFnc);
  const res = await callRequest.json();
  const condStop = setCtDataError(res, callRequest.status);
  if (condStop !== 'follow') return;
  // setCtDataError(callRequest);

  // ---------------------------
  // ----- check IF ERROR / STOP
  // ---------------------------
  const condShow = getCtData('all.apis.msgs.condShow');
  const condError = condShow === 'true';

  if (condError)
    return console.log(
      'Depois do Fetch - CARTÃO - createOrder - PROMISE',
      condError,
      callRequest,
    );

  // ----------------------
  // ----- check IF SUCCESS
  // ----------------------
  if (!condError) {
    const css1 =
      'color: #7c0046; background-color: #99df00; font-size: 11px; font-weight: bold; padding: 2px 6px; border-radius: 3px';
    // const res = await callRequest.json();
    setData({ path: 'sc.B4.currData.checkout.paymentData', value: res });

    // ------------------------------------
    // ------ CREATE NEW RENT DOCUMENT ----
    // -------------------------------------
    const fireInit = getCtData('all.fireInit');
    const passProps1 = {
      fbInit: [fireInit],
      arrRefStrings: ['rents'],
      arrPathData: ['sc.B4.currData.checkout'],
      arrFuncs: [
        async (...args) => {
          // ----------------------------------
          // ------ UPDATE USER WITH TOKEN ----
          // ----------------------------------
          const dataToUpdate = {
            ['activeRentData.rentId']: argSel(args, '#0.docId'),
          };
          setData({ path: 'all.tempData', value: dataToUpdate });

          // ----------------------------------
          // ---------- set Firestore TimerData
          // ----------------------------------
          const selectedUser = getCtData('all.userData.docId');
          const fireInit = getCtData('all.fireInit');
          const passProps2 = {
            fbInit: [fireInit],
            arrRefStrings: ['users', selectedUser],
            arrPathData: ['all.tempData'],
            arrFuncs: [
              () => {
                setData({ path: 'all.toggles.loaderPurchase', value: null });
              },
              async () => {
                const locationType = getCtData(
                  'sc.B3A.currData.currLocation.data.locationType',
                );
                const arrayAutoBikes = getCtData('sc.B3C.currData.mainList');
                const stationApiID = getCtData(
                  'sc.B3A.currData.currLocation.data.apiLocationID',
                );
                console.log('createOrder: stationApiID', { stationApiID });

                // ---- Garantir que Apenas Bikes Liberadas sejam acionadas
                const arrayBayIds = arrayAutoBikes
                  .filter(
                    item =>
                      item.rackStatus === 'lock' && item.status === 'available',
                  )
                  .map(item => ({
                    currId: item.rackID,
                    actions: 'unlock' as const,
                    stationApiID,
                  }));

                // ----- Destravar a Bike
                await unlockBike(arrayBayIds);

                if (locationType === 'Autônomo') {
                  setData({
                    path: 'sc.B3A.currData.currLocation.data',
                    value: {},
                  });
                  goTo('b5timerAuto');
                }

                if (locationType === 'Supervisionado') {
                  goTo('b5timer');
                }
              },
            ],
          };

          await updateDocTool({ args, pass: passProps2 });

          // clean temp data
          setData({ path: 'all.tempData', value: null });
        },
      ],
    };

    await setDocTool({ args: {}, pass: passProps1 });

    console.log('%ccreateOrder - SUCCESS!!!', css1, res);

    return res;
  }
};

export const createOrder = async (props?: Tprops) => {
  let bikesList: TMergedLocalBikes[] = getCtData(checkoutPath + '.bikesList');
  const currLocationId = getCtData('sc.B4.currData.checkout.locationId');
  console.log({ bikesList });

  const docsToUpdate: DocumentReference[] = [];

  try {
    // Etapa 1: validação apenas (não atualiza ainda)
    await runTransaction(firestoreOutFlax, async transaction => {
      for (const currBike of bikesList) {
        console.log({ currBike });
        for (const currID of currBike.allLocalIds) {
          const ref = doc(
            firestoreOutFlax,
            'locations',
            currLocationId,
            'localBikes',
            currID,
          );

          const snap = await transaction.get(ref);
          if (!snap.exists()) throw new Error(`Bike ${currID} não existe`);

          const data = snap.data();
          if (data.status !== 'available') {
            throw new Error(
              `Bike ${
                currBike.modelName ?? currID
              } já foi alugada por outra pessoa.`,
            );
          }

          docsToUpdate.push(ref); // ← armazena para depois do pagamento
        }
      }
    });

    // Etapa 2: pagamento
    const res = await payAndSetFireBase(props);
    if (!res) throw new Error('Pagamento não confirmado');

    // Etapa 3: agora sim atualiza os status
    const arrPromises = docsToUpdate.map(ref =>
      updateDoc(ref, { status: 'unavailable' }),
    );
    await Promise.all(arrPromises);

    console.log('Status das bikes atualizado para "unavailable" com sucesso');
  } catch (err: any) {
    console.error('Erro no fluxo do Cartão de Crédito:', err.message);
    setErrorTrue(err.message);
    setData({ path: 'all.toggles.loaderPurchase', value: null });
    return;
  }
};
